import { gql } from '@apollo/client';

export const READ_PARKING_SESSION_RETRY_STATUS = gql`
  query ReadParkingSessionRetryStatus($sessionId: ID!) {
    readParkingSession(sessionId: $sessionId) {
      sessionId
      paymentState
    }
  }
`;
